module.exports = __webpack_public_path__ + "img/QV.616503a8.png";